import React from 'react';
import i18next from 'i18next';
import ButtonBorder from '../Button/ButtonBorder';
import Icon from '../Icon/Icon';
import logo from 'icons/logo.svg';

export default class AdultControl extends React.PureComponent {
  constructor(props) {
    super(props);

    const show = localStorage.getItem('age-confirmed') !== 'true';

    if (show) {
      document.body.classList.add('locked');
    }

    this.state = {
      show,
    };
  }

  confirm = (answer) => {
    localStorage.setItem('age-confirmed', answer);

    if (!answer) {
      history.back();
    } else {
      this.setState({ show: false });
      document.body.classList.remove('locked');
    }
  };

  render() {
    if (!this.state.show) return null;

    return (
      <div className="adult-control">
        <Icon glyph={logo} className="adult-control__logo" />
        <div className="adult-control__buttons">
          <ButtonBorder
            className="adult-control__yes"
            onClick={this.confirm.bind(this, true)}
          >
            {i18next.t('adult_control.confirm')}
          </ButtonBorder>
          <ButtonBorder
            className="adult-control__no"
            onClick={this.confirm.bind(this, false)}
          >
            {i18next.t('adult_control.decline')}
          </ButtonBorder>
        </div>
        <div className="adult-control__text">
          {i18next.t('adult_control.rules')}
        </div>
        <div className="adult-control__note">
          {i18next.t('adult_control.disclaimer')}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/AdultControl/AdultControl.jsx